import { ReactComponent as TetherIcon } from '@/assets/tokens/tether-green.svg';
import { ReactComponent as TetherWhiteIcon } from '@/assets/tokens/tether-white.svg';
import { ReactComponent as TournamentDollarsIcon } from '@/assets/tokens/tournament-dollars.svg';
import { ReactComponent as TournamentTicketIcon } from '@/assets/tokens/tournament-ticket.svg';
import { TicketType } from '@repo/common-types';

type DenominationType = 'usdt' | 'tournament_dollars' | 'ticket';

const getDenominationType = (ticketType?: string | null, isTournamentDollars?: boolean): DenominationType => {
  if (isTournamentDollars) return 'tournament_dollars';
  if (!ticketType) return 'usdt';
  if (ticketType === TicketType.USDT) return 'tournament_dollars';
  if (ticketType === TicketType.TOURNAMENT) return 'ticket';
  return 'usdt';
};

const CurrencyDisplay = ({
  amount,
  iconSize = '22px',
  ticketType,
  isTournamentDollars,
}: {
  amount: number;
  iconSize?: string;
  ticketType?: string | null;
  isTournamentDollars?: boolean;
}) => {
  const denominationType = getDenominationType(ticketType, isTournamentDollars);

  const renderIcon = () => {
    const style = { width: iconSize, height: iconSize };

    switch (denominationType) {
      case 'tournament_dollars':
        return <TournamentDollarsIcon className="mb-0 text-xl" style={style} />;
      case 'ticket':
        return <TournamentTicketIcon className="mb-0 text-xl" style={style} />;
      case 'usdt':
      default:
        if (amount > 0) {
          return <TetherIcon className="mb-0 text-xl" style={style} />;
        }
        return <TetherWhiteIcon className="mb-0 text-xl" style={{ ...style, opacity: 0.3 }} />;
    }
  };

  const formatAmount = () => {
    if (denominationType === 'ticket') {
      return '1';
    }
    return amount?.toFixed(2);
  };

  return (
    <div className="d-flex align-items-center justify-content-start gap-2">
      {formatAmount()}
      {renderIcon()}
    </div>
  );
};

export default CurrencyDisplay;
